import { Component, OnInit,HostListener } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { HelperService } from '../helper.service';
import { Http, Response } from '@angular/http';
import { Subject } from 'rxjs/Subject';
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css'],
  providers: [HelperService] 
})
export class PaymentComponent implements OnInit {
  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
  datas:any=[];
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  constructor(private http:Http, private helper:HelperService) { }

  ngOnInit() {
  	this.http.get(this.helper.base_url+'http/get/payments')
      .map(this.extractData)
      .subscribe(data => {       
        this.datas = data;
        this.dtTrigger.next();
      });
  }
    private extractData(res: Response) {
    const body = res.json();
    return body.data || {};
  }

}



// WEBPACK FOOTER //
// ./src/app/payment/payment.component.ts